import React from 'react';
import { Link } from 'react-router-dom';
import AsyncState from '../components/AsyncState';
import LifecycleShell from '../components/LifecycleShell';
import StatusBadge from '../components/StatusBadge';
import { useLanguage } from '../contexts/LanguageContext';
import { useApi } from '../hooks/useApi';
import { translations } from '../translations';
import { fillTemplate } from '../utils/format';

const POLL_MS = 30000;
const METRIC_STATUSES = ['request_submitted', 'waiting_asset', 'custom_development', 'google_play_review', 'published', 'build_failed'];

export default function DashboardPage() {
  const { language } = useLanguage();
  const t = translations[language];
  const summary = useApi('/dashboard/custom-app-summary', { pollMs: POLL_MS });
  const data = summary.data || {};
  const byStatus = data.byStatus || {};
  const attention = data.attention || [];

  return <LifecycleShell title={t.dashboardTitle}>
    <AsyncState state={summary} retry={summary.retry}>
      <div className="metric-grid">
        <Link className="metric" to="/custom-apps"><span>{t.metricTotal}</span><strong>{data.total || 0}</strong></Link>
        {METRIC_STATUSES.map((status) => <Link className="metric" key={status} to={`/custom-apps?status=${status}`}>
          <span>{t.statusLabel[status]}</span><strong>{byStatus[status] || 0}</strong>
        </Link>)}
      </div>
      <section className="card" aria-labelledby="attention-heading">
        <div className="card__head">
          <div>
            <p className="page-head__eyebrow">{t.attentionEyebrow}</p>
            <h2 id="attention-heading">{t.attentionTitle}</h2>
            {data.attentionTotal > 0 && <p className="card__sub">{fillTemplate(t.attentionCount, { count: data.attentionTotal })}</p>}
          </div>
          <Link className="btn btn--pill" to="/custom-apps">{t.viewAllApps}</Link>
        </div>
        {attention.length === 0
          ? <div className="empty"><strong>{t.attentionEmpty}</strong></div>
          : <div className="row-list">
            {attention.map((item) => <Link className="row" to={`/custom-apps/${item.id}`} key={item.id}>
              <span className="row__main">
                <span className="row__title">{item.appName || t.untitledApp}</span>
                <span className="row__meta">{item.company?.name || t.unmappedCompany}</span>
                <span className="row__meta row__meta--warn">{(item.reasons || []).map((reason) => t.reasonLabel[reason] || reason).join(' · ')}</span>
              </span>
              <span className="row__side"><StatusBadge status={item.status} /></span>
            </Link>)}
          </div>}
      </section>
    </AsyncState>
  </LifecycleShell>;
}
